import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid2,
  IconButton,
  MenuItem,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React, { useState, useMemo } from "react";
import { ReactComponent as ExpandIcon } from "Assets/Icons/Leaderboard/ExpandIcon.svg";
import { ReactComponent as CollapseIcon } from "Assets/Icons/Leaderboard/CollapseIcon.svg";
import { ReactComponent as AlertIcon } from "Assets/Icons/Leaderboard/AlertIcon.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { StyledMenu } from "Components/Common/StyledMenu";
import PrimarySlider from "Components/Common/PrimarySlider";
import { SwiperSlide } from "swiper/react";
import AllQuestions from "./Questions/AllQuestions";
import QuestionDetail from "./Questions/QuestionDetail";
import Instructions from "./Instructions";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
});

const AssignmentTab = () => {
  const { tab } = useParams();
  const [isOpen, setIsOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedQue, setSelectedQue] = useState(0);

  const [selectedFilter, setSelectedFilter] = useState(
    "problem_solving_percentage"
  );

  let sortList = {
    problem_solving_percentage: "Problem Solving Percentage",
    reputation_points: "Reputation Points",
    problem_solving_streaks: "Problem Solving Streak",
  };

  const { Assignments, Problems, Translation } = useSelector((state) => ({
    Assignments: state.Assignment.questions || [],
    Problems: state.AdditionalProblem.questions || [],
    Translation: state.Translation.translation?.Course || {},
  }));

  const Questions = useMemo(() => {
    return tab === "problems" ? Problems : Assignments
  }, [tab, Assignments, Problems])

  return (
    <>
      <Grid2 sx={styles}>
        <Instructions />
        <Typography color="secondary.light">
          {Translation?.SolvingAssignmentProblem}
        </Typography>
        {/* <Button
          endIcon={<KeyboardArrowDownIcon />}
          sx={{ width: "fit-content" }}
          variant="outlined"
          size="small"
          color="primary"
          outlinedFilled
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          Sort By: &nbsp;
          <Typography fontWeight={500} variant="subtitle">
            {" "}
            {sortList[selectedFilter]}
          </Typography>
        </Button> */}
        <StyledMenu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          <Typography
            variant="subtitle"
            display={"flex"}
            p={"6px 16px"}
            fontWeight={500}
            color="secondary.light"
          >
            {Translation?.SortRankBy}
          </Typography>
          {Object.entries(sortList)?.map(([key, value], i) => {
            return (
              <MenuItem
                onClick={() => {
                  setSelectedFilter(key);
                  setAnchorEl(null);
                }}
                key={i}
              >
                {value}
              </MenuItem>
            );
          })}
        </StyledMenu>
        <Box width={"100%"}>
          <PrimarySlider
            slidesPerView={{
              1200: { slidesPerView: 7 },
              900: { slidesPerView: 5 },
              600: { slidesPerView: 3 },
              0: { slidesPerView: 2 },
            }}
            spacing={"15px"}
          >
            { Array.isArray(Questions) && Questions.length  && [Translation?.All, ...Questions]?.map((item, i) => {
              return (
                <SwiperSlide key={i}>
                  <Box
                    onClick={() => setSelectedQue(i)}
                    sx={(theme) => ({
                      border: `1px solid ${theme.palette.border.blue}`,
                      borderRadius: "8px",
                      padding: "10px",
                      textAlign: "center",
                      cursor: "pointer",
                      fontWeight: 500,
                      ...(selectedQue == i && {
                        color: theme.palette.white.main,
                        background: theme.palette.primary.main,
                      }),
                    })}
                  >
                    {i == 0 ? item : `${Translation?.Question} ${i}`}
                  </Box>
                </SwiperSlide>
              );
            })}
          </PrimarySlider>
        </Box>
        {selectedQue == 0 ? <AllQuestions setSelectedQue={setSelectedQue} questions={Questions} /> : <QuestionDetail question={Questions[selectedQue - 1]} totalQuestions={Questions?.length || 0} selectedQue={selectedQue} setSelectedQue={setSelectedQue} isScore={tab === "assignments"} />}
      </Grid2>
    </>
  );
};

export default AssignmentTab;
